import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppConfig } from '../app.config';
import { Observable } from 'rxjs';

@Injectable()
export class ChartUiService {

  constructor(
    private http: HttpClient,
    private config: AppConfig
  ) {
  }

  public colorsMaxValue(values: number[], primaryColor: string, maxColor: string): Array<string> {
    const arr = Object.assign([], values);
    const maxVal = arr.sort().reverse()[0];
    return values.map(it => {
      return it === maxVal ? maxColor : primaryColor;
    });
  }

  ticketPerMonth(year): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('year', year)
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('ticket/per_month'), { params: params });
  }

  ticketPerUserType(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('ticket/per_user_type'), { params: params });
  }

  ticketPerTransportMode(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('ticket/per_transportation_mode'), { params: params });
  }

  ticketPerStatus(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('ticket/per_status'), { params: params });
  }

  ticketPerProject(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('ticket/per_project'), { params: params });
  }

  ticketPerCategory(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('ticket/per_category'), { params: params });
  }

  routePerGender(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('route/per_gender'), { params: params });
  }

  routePerTransportMode(): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('route/per_transportation_mode'), { params: params });
  }

  routePerMonth(year): Observable<any> {
    const project = JSON.parse(localStorage.getItem('project_id'));
    let params = new HttpParams()
      .set('include_sub_projects', 'true')
      .set('year', year)
      .set('project_id', project.projectID.id);
    return this.http.get<boolean>(this.config.getEndpoint('route/per_month'), { params: params });
  }
}
